<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <div v-if="action == 'create'">
                                                <CreateHiringNote />
                                            </div>
                                            <div v-else-if="action == 'view'">
                                                <ViewHiringNote />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import CreateHiringNote from './CreateHiringNote.vue'
import ViewHiringNote from './GetHiringNote.vue'


export default {
    name: 'HiringNote',

    data(){
        return{
            action: ""
        }
    },

    components:{
        navbar1,
        navbar2,
        CreateHiringNote,
        ViewHiringNote
    },

    mounted(){
        this.action = this.$route.params.action
    },
    methods: {
        
    },
    computed: {
        
    }
}
</script>
